export default __webpack_public_path__ + "static/media/clock-action.af891798.svg";